import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Diligência",
  path: "/prestacaocontas/pcoprojetodiligencia",
  name: "pcoprojetodiligencia",
  component: () => import("@/views/prestacaocontas/pcoprojetodiligencia/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.DILIGENCIASNOVO_MENU_1500200199],
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Diligência",
  path: "/prestacaocontas/pcoprojetodiligencia/cadastro/:id?",
  parent: "pcoprojetodiligencia",
  name: "pcoprojetodiligencia_create",
  component: () => import("@/views/prestacaocontas/pcoprojetodiligencia/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.DILIGENCIASNOVO_MENU_1500200199],
  },
  goesToMenu: true,
 },
]
